
/*
    id:int = Column(Integer, primary_key=True, autoincrement=True)
    event_name:str = Column(String(255))
* */
class RuralEventType_Helper {
    getRuralEventType() {
        return null;

    }
    GetMapTypeForSelectors()
    {
        const eventTypeMap = {
            CALL_EVENT: "Call",
            SCRAP_DATA_EVENT: "Scrap Data",
            LUNCH_AND_LEARN_EVENT: "Lunch and Learn",
            COUPON_EVENT: "Coupon",
            WEB_INQUIRY_EVENT: "Web Inquiry",
            SPEC_LINK_EVENT: "SpecLink",
            GET_CERTIFIED_EVENT: "Get Certified",
            LINKEDIN_FOLLOWER_EVENT: "LinkedIn Follower",
            NEWSLETTER_EVENT: "Newsletter",
            LINKEDIN_INVITATION_EVENT: 'LinkedIn Invitation',
            ARCHITECTPACKAGE_SENT_EVENT:  'Architect package Sent',
            FOCERTIFIEDAPPLICATORINVITATION_EVENT:  'FO Certified Applicator Invitation',
            FOCERTIFIEDAPPLICATOR_EVENT:  'FO Certified Applicator',
        };

        return eventTypeMap;
    }

    MakeSelectorData() {
        const mapNames = this.GetMapTypeForSelectors();
        const res = this.EventType.map(el => {
            const txt = mapNames[el['event_name']];
            const id = el['id'].toString();
            return {
                'text': txt,
                'value': id,
            };
        });
        return res;
    }

    Id2Value(int_id){
        let event_el = this.EventType.find(el => el['id'] === int_id);
        const mapdata = this.GetMapTypeForSelectors();
        const res = mapdata[event_el['event_name']];
        return res;
    }

    EventTypesData = [];
}

export default RuralEventType_Helper ;
